import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAmazonRegistry } from './context/AmazonBrandRegistryContext';
import './VendrLayout.css';

const VendrLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { isAmazonEnabled, isAmazonSubmitted } = useAmazonRegistry();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="vendr-layout">
      <header className="vendr-header">
        <div className="vendr-header-container">
          <button type="button" className="vendr-burger-menu" onClick={toggleSidebar} aria-label="Toggle menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <Link to="/vendr" className="vendr-logo">
            <img src="/logo-wide.png" alt="MarketVendr" className="vendr-logo-image" />
            <span className="vendr-badge">Vendr Dashboard</span>
          </Link>
          <div className="vendr-header-user">
            {user && <span className="vendr-welcome">Welcome, {user.email}</span>}
          </div>
        </div>
      </header>

      <div className="vendr-dashboard-container">
        {sidebarOpen && <div className="vendr-sidebar-overlay" onClick={closeSidebar} aria-hidden="true" />}

        <aside className={`vendr-sidebar ${sidebarOpen ? 'vendr-sidebar-open' : ''}`}>
          <nav className="vendr-sidebar-nav">
            <Link
              to="/vendr"
              className={`vendr-sidebar-link ${location.pathname === '/vendr' ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span>Dashboard</span>
            </Link>
            <Link
              to="/vendr/products"
              className={`vendr-sidebar-link ${location.pathname.startsWith('/vendr/products') ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              <span>Products</span>
            </Link>
            {isAmazonEnabled && (
              <Link
                to="/vendr/amazon-registry"
                className={`vendr-sidebar-link ${location.pathname === '/vendr/amazon-registry' ? 'active' : ''}`}
                onClick={closeSidebar}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span>Amazon Registry</span>
                {!isAmazonSubmitted && (
                  <span className="vendr-sidebar-badge-required">Required</span>
                )}
              </Link>
            )}
          </nav>
          <div className="vendr-sidebar-footer">
            <Link
              to="/vendr/settings"
              className={`vendr-sidebar-footer-link ${location.pathname === '/vendr/settings' ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <span>Settings</span>
            </Link>
            <button type="button" className="vendr-sidebar-footer-link vendr-sidebar-logout" onClick={() => { closeSidebar(); handleLogout(); }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Logout</span>
            </button>
          </div>
        </aside>

        <main className="vendr-main">{children}</main>
      </div>
    </div>
  );
};

export default VendrLayout;
